import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './status-done.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function StatusDone(props: IconProps) {
  return <Icon tw="fill-current" className={props.className} />;
}
